import {
  WalkieTalkieAction,
  SET_ACTIVE_CHANNEL,
  DISABLE_ALL_CHANNELS,
  SWITCH_CHANNEL,
  START_TALKING,
  STOP_TALKING,
  START_LISTENING,
  STOP_LISTENING,
  START_CHANNEL_TIMER,
  RESET_CHANNEL_TIMER,
  STOP_CHANNEL_TIMER,
  CHANNEL_TIMEOUT,
} from './WalkieTalkieAction';
import { WalkieTalkieState, initialWalkieTalkieState } from './WalkieTalkieState';

export const walkieTalkieReducer = (
  state: WalkieTalkieState = initialWalkieTalkieState,
  action: WalkieTalkieAction
): WalkieTalkieState => {
  switch (action.type) {
    case SET_ACTIVE_CHANNEL:
      // Ferma il timer precedente se esiste
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        activeChannelSentinelId: action.payload.sentinelId,
        activatedBy: action.payload.activatedBy,
        isTalking: false,
        isListening: true, // Entra automaticamente in ascolto
        lastActivity: Date.now(),
        timerHandle: null, // Verrà impostato da START_CHANNEL_TIMER
      };

    case DISABLE_ALL_CHANNELS:
      // Ferma il timer se esiste
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        activeChannelSentinelId: null,
        activatedBy: null,
        isTalking: false,
        isListening: false,
        timerHandle: null,
        lastActivity: 0,
      };

    case SWITCH_CHANNEL:
      // Ferma il timer precedente se esiste
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        activeChannelSentinelId: action.payload.toSentinelId,
        activatedBy: action.payload.activatedBy,
        isTalking: false,
        isListening: true, // Entra automaticamente in ascolto
        lastActivity: Date.now(),
        timerHandle: null, // Verrà impostato da START_CHANNEL_TIMER
      };

    case START_TALKING:
      return {
        ...state,
        isTalking: true,
        isListening: false, // Durante trasmissione non si ascolta
        lastActivity: Date.now(), // Aggiorna timestamp attività
      };

    case STOP_TALKING:
      return {
        ...state,
        isTalking: false,
        isListening: true, // Torna ad ascolto dopo trasmissione
        lastActivity: Date.now(),
      };

    case START_LISTENING:
      return {
        ...state,
        isListening: true,
        isTalking: false,
      };

    case STOP_LISTENING:
      return {
        ...state,
        isListening: false,
      };

    case START_CHANNEL_TIMER:
      // Ferma il timer precedente se esiste
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        timerHandle: action.payload,
      };

    case RESET_CHANNEL_TIMER:
      // Il timer verrà effettivamente resettato dal componente
      // Questo aggiorna solo il timestamp
      return {
        ...state,
        lastActivity: Date.now(),
      };

    case STOP_CHANNEL_TIMER:
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        timerHandle: null,
      };

    case CHANNEL_TIMEOUT:
      // Timer scaduto - spegne canale automaticamente
      if (state.timerHandle) {
        clearTimeout(state.timerHandle);
      }
      return {
        ...state,
        activeChannelSentinelId: null,
        activatedBy: null,
        isTalking: false,
        isListening: false,
        timerHandle: null,
        lastActivity: 0,
      };

    default:
      return state;
  }
};
